<template lang="pug">
  .applications__list
    .applications-page__title Проекты
    template(
      v-for="(application) in apps"
    )
      the-application(
        :application="application"
      )
</template>

<script>
import { mapState } from 'vuex';
import {
  GET_APPS,
} from '../constants';
import TheApplication from './TheApplication.vue';

export default {
  name: 'ApplicationsList',

  components: {
    TheApplication,
  },

  computed: {
    ...mapState({
      apps: state => state.apps,
    }),
  },

  created() {
    return this.$store.dispatch(GET_APPS);
  },
};
</script>

<style lang="scss" scoped>
  .applications__list {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;

    @include tablet {
      margin-left: 16px;
      margin-right: 16px;
    }
  }

  .applications-page__title {
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    margin-top: 40px;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 18px;

    @include tablet {
      margin-left: 4px;
    }

    @include mobile {
      margin-top: 22px;
      font-size: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ApplicationsList.vue